var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenEyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.2504 4.007C12.6334 1.4641 10.2674 0 7.77539 0C6.52939 0 5.31839 0.364273 4.21239 1.04378C3.10639 1.7303 2.11239 2.73205 1.30039 4.007C0.600391 5.10683 0.600391 6.89317 1.30039 7.99299C2.91739 10.5429 5.28339 12 7.77539 12C9.02139 12 10.2324 11.6357 11.3384 10.9562C12.4444 10.2697 13.4384 9.26795 14.2504 7.99299C14.9504 6.90018 14.9504 5.10683 14.2504 4.007ZM7.77539 8.83363C6.20739 8.83363 4.94739 7.56567 4.94739 6.0035C4.94739 4.44133 6.20739 3.17338 7.77539 3.17338C9.34339 3.17338 10.6034 4.44133 10.6034 6.0035C10.6034 7.56567 9.34339 8.83363 7.77539 8.83363Z",
    fill: "#26875C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77189 4C6.67206 4 5.77539 4.89667 5.77539 6.0035C5.77539 7.10333 6.67206 8 7.77189 8C8.87171 8 9.77539 7.10333 9.77539 6.0035C9.77539 4.90368 8.87171 4 7.77189 4Z",
    fill: "#26875C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEyeIcon);
export default __webpack_public_path__ + "static/media/OpenEyeIcon.1b2526dea6bffdce425a250872fe3b33.svg";
export { ForwardRef as ReactComponent };